import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./DataNotFound.scss";

function DataNotFound({ text = "No data found" }) {
  return (
    <div className="data-state-wrapper">
      <h6 className="mb-0">
        <FontAwesomeIcon icon={faInfoCircle} className="text-info me-1" />
        {text}
      </h6>
    </div>
  );
}

export default DataNotFound;
